

import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

declareVrunComponent('vonagePlayer.vrun.component', () => import ('./components/VonagePlayer.vue'))
